import { api } from './client'

export const getAccounts = async () => {
  const { data } = await api.get('/master/accounts')
  return data
}

export const createAccount = async (payload) => {
  const { data } = await api.post('/master/accounts', payload)
  return data
}


export const getVendors = async () => {
  const { data } = await api.get('/master/vendors')
  return data
}

export const createVendor = async (payload) => {
  const { data } = await api.post('/master/vendors', payload)
  return data
}

export const getProducts = async (params) => {
  const { data } = await api.get('/master/products', params ? { params } : undefined)
  return data
}

export const createProduct = async (payload) => {
  const { data } = await api.post('/master/products', payload)
  return data
}

export const getLocations = async () => {
  const { data } = await api.get('/master/locations')
  return data
}

export const createLocation = async (payload) => {
  const { data } = await api.post('/master/locations', payload)
  return data
}

export const getCustomers = async () => {
  const { data } = await api.get('/master/customers')
  return data
}

export const createCustomer = async (payload) => {
  const { data } = await api.post('/master/customers', payload)
  return data
}

export const getControlAccounts = async () => {
  const { data } = await api.get('/master/control-accounts')
  return data
}

export const saveControlAccounts = async (mapping) => {
  const { data } = await api.post('/master/control-accounts', { mapping })
  return data
}

// Setup helpers
export const getSetupStatus = async () => {
  const { data } = await api.get('/master/setup/status')
  return data // { has_accounts, has_minimal_retail, has_control_mappings, ... }
}

export const seedRetail = async () => {
  const { data } = await api.post('/master/setup/seed-retail', {})
  return data // { created, updated, mapping }
}

export const getUsers = async () => {
  const { data } = await api.get('/master/users')
  return data
}

export const getUser = async (user_id) => {
  const { data } = await api.get(`/master/users/${user_id}`)
  return data
}

export const uploadUserPhoto = async (file, user_id) => {
  const form = new FormData()
  form.append('file', file)
  if (user_id != null) form.append('user_id', String(user_id))
  const { data } = await api.post('/master/users/photo', form, { headers: { 'Content-Type': 'multipart/form-data' } })
  return data
}

export const createUser = async (payload) => {
  const { data } = await api.post('/master/users', payload)
  return data
}

// Product discounts
export const getProductDiscount = async (product_id) => {
  const { data } = await api.get('/master/product-discount', { params: { product_id } })
  return data // { product_id, discount_type, discount_value } | {}
}

export const saveProductDiscount = async ({ product_id, discount_type, discount_value }) => {
  const { data } = await api.post('/master/product-discount', { product_id, discount_type, discount_value })
  return data // { product_id, action }
}

export const deleteAccount = async (accountId) => (await api.delete(`/master/accounts/${accountId}`)).data
export const getSetupStandard = async () => (await api.get('/master/setup/standard')).data
/** The standard account of each built-in default: {role: code}. */
export const getStandardDefaults = async () => (await api.get('/master/standard-defaults')).data

// Cash and bank accounts (the Cash and Card payments defaults) for payment pickers.
/** Accounts to pick from: kinds is 'Cash,Card', 'AR' or 'AP'. */
/** use: 'in' (customer payments) or 'out' (vendor payments) marks each account's automatic methods (auto). */
export const getDefaultChoices = async (kinds = 'Cash,Card', locationId, use) => (await api.get('/master/default-choices', { params: { kinds, ...(locationId ? { location_id: locationId } : {}), ...(use ? { use } : {}) } })).data
export const getDefaultExtras = async () => (await api.get('/master/default-extras')).data
export const saveDefaultExtras = async (payload) => (await api.post('/master/default-extras', payload)).data

/** Who owns the business: 'sole' or 'company'. Names the equity accounts to match. */
export const setBusinessType = async (business_type) => (await api.post('/master/setup/business-type', { business_type })).data
